import * as React from "react";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import { Button } from "carbon-components-react";
import { Save16 } from "@carbon/icons-react";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface CQMHurdleModalProps extends HurdleProps {
  onSave: Function;
  changesMade: boolean;
}

const CQMHurdleModal: React.FC<CQMHurdleModalProps> = ({
  app,
  hurdle,
  onHide,
  children,
  changesMade,
  onSave,
}) => (
  <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
    <div className="dashboard-container">
      <div className="cqm-info-review__modal-body">{children}</div>
      {changesMade ? (
        <footer className={styles.footer}>
          <Button kind="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button onClick={onSave} renderIcon={Save16}>
            Save changes
          </Button>
        </footer>
      ) : (
        <footer className={styles.footer}>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </footer>
      )}
    </div>
  </HurdleView>
);

export default CQMHurdleModal;
